import React from "react";
import Grid from "@material-ui/core/Grid";
import { Page, Icon, Card, TextStyle } from "@shopify/polaris";
import {
  ListMajor,
  ImagesMajor,
  CollectionsMajor,
  CalendarMajor,
  LocationMajor,
} from "@shopify/polaris-icons";
import history from "../../Assets/Lib/history";
import NavigationLayout from "../../Components/NavigationLayout";
import { useNavigate } from "react-router-dom";

const GridEvents = () => {
  const navigate = useNavigate();

  return (
    <NavigationLayout>
      <Page>
        <Card>
          <div style={{ padding: 20 }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className="gridItem"
                  onMouseDown={(e) => navigate("/admin/manage-events/events")}
                >
                  <div className="iconDiv">
                    <Icon
                      source={CalendarMajor}
                      style={{ margin: "0 5px" }}
                      color="subdued"
                    ></Icon>
                  </div>
                  <div style={{ flexDirection: "column", marginLeft: "10" }}>
                    <div className="titleDev">
                      <TextStyle>Events</TextStyle>
                    </div>
                    <div className="description">
                      <TextStyle></TextStyle>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className="gridItem"
                  onMouseDown={(e) => navigate("/admin/manage-events/types")}
                >
                  <div className="iconDiv">
                    <Icon
                      source={CollectionsMajor}
                      style={{ margin: "0 5px" }}
                      color="subdued"
                    ></Icon>
                  </div>
                  <div style={{ flexDirection: "column", marginLeft: "10" }}>
                    <div className="titleDev">
                      <TextStyle>Types</TextStyle>
                    </div>
                    <div className="description">
                      <TextStyle></TextStyle>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className="gridItem"
                  onMouseDown={(e) =>
                    navigate("/admin/manage-events/locations")
                  }
                >
                  <div className="iconDiv">
                    <Icon
                      source={LocationMajor}
                      style={{ margin: "0 5px" }}
                      color="subdued"
                    ></Icon>
                  </div>
                  <div style={{ flexDirection: "column", marginLeft: "10" }}>
                    <div className="titleDev">
                      <TextStyle>Locations</TextStyle>
                    </div>
                    <div className="description">
                      <TextStyle></TextStyle>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Page>
    </NavigationLayout>
  );
};
export default GridEvents;
